import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import alertGiftMilitaryPng from '@/assets/landing/alert-gift-military-calisthenics.png'
import militaryAge18Png from '@/assets/landing-activity-male/military-18.png'
import militaryAge30Png from '@/assets/landing-activity-male/military-30.png'
import militaryAge40Png from '@/assets/landing-activity-male/military-40.png'
import militaryAge50Png from '@/assets/landing-activity-male/military-50.png'

const schema: LandingScreenSchema = {
	order: ['LandingAlert', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingAlert: ({ $t }): LandingComponentsConfig['LandingAlert'] => ({
			// Reuse the shared (localized) printable-alert copy, but recolor the "printable guide"
			// highlight to the exact Figma orange #D17D17. No DS token matches it (--Fill-Orange-100
			// #ee8834 is the nearest but differs), so per the design-system fallback we use the Figma
			// hex inline. Rewriting the span's class→style keeps every locale intact — no new i18n key.
			text: $t('female_yoga.pages.landing.alert_text').replace("class='text-primary'", "style='color: #D17D17'"),
			icon: alertGiftMilitaryPng,
			backgroundColor: 'var(--Fill-Orange-16)',
			customStyles: {
				marginTop: 'var(--size-20)',
				// Figma banner padding: 12px 20px (component default is 16px 20px).
				padding: 'var(--size-12) var(--size-20)',
			},
		}),

		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('military_calisthenics.pages.landing.age.title'),
			uppercase: true,
			size: 'large',
			customStyles: {
				marginLeft: '1rem',
				marginRight: '1rem',
			},
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			title: $t('female_yoga.pages.landing.quiz'),
			// Figma subtitle color = Text/Secondary (--Text-Primary-60 = rgba(50,54,83,0.6) / #32365399).
			customStyles: {
				color: 'var(--Text-Primary-60)',
			},
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'military',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-29',
					label: $t('female_activity.pages.landing.step_1.options.18_29'),
					img: militaryAge18Png,
				},
				{
					value: 30,
					analyticValue: '30-39',
					label: $t('female_activity.pages.landing.step_1.options.30_39'),
					img: militaryAge30Png,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_activity.pages.landing.step_1.options.40_49'),
					img: militaryAge40Png,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_activity.pages.landing.step_1.options.50'),
					img: militaryAge50Png,
				},
			],
		}),
	},
}

export default schema
